import { createClient } from '@supabase/supabase-js';


// Obtén estos valores desde tu panel de Supabase -> Project Settings -> API
const supabaseUrl = "https://nztigqsmanuohoooeybf.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56dGlncXNtYW51b2hvb29leWJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkxOTQwODUsImV4cCI6MjA3NDc3MDA4NX0.6bLuxdaOxwCViIodH-z3oKYWvx7nJkHeL8TQsUDpL1o";





export const supabase = createClient(supabaseUrl, supabaseAnonKey);
